// Это глобальный middleware. Почему? Потому что в options api какого-то
// хуя не работает обычный, так-же не работает fetch
// поэтому временно это глобальный middleware, потом перепишем на хук

import { getArticleFetchApi } from '~/utils/apiUtils';
import { isArchivePage } from '~/utils/router';
import { usePageStore } from '~/store/pagesData';
import { useAdfoxStore } from '~/store/adfoxParams';
import type { RouteLocationNormalizedGeneric } from 'vue-router';
import type { IWordpressApi } from '~/api/wordpress';
import { handleApiError } from '@devhacker/shared/utils/handleApiError';
import { PageSeoInputSchema } from '~/domains/head/seo/api/transformSeo';
import { parseSeoOrThrow } from '~/domains/head/seo/services/parseSeoOrThrow';

type SeoResponse = {
  title?: string;
  data?: unknown;
};

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.client) return;
  if (useError().value) return;
  if (!isArchivePage(to?.name as string)) return;

  const app = useNuxtApp();
  const { $wordpressApi, $logger, runWithContext } = app;

  const log = $logger.withScope('🏛️ fetchArchivePageData');
  const pageStore = usePageStore();
  const adfoxStore = useAdfoxStore();

  const pageNumber = Array.isArray(to.query.page) ? to.query.page[0] : to.query.page;
  log('pageNumber', pageNumber);

  const fetchApi = getArticleFetchApi(to, app);
  const fetchArticles = fetchApi.fetchArticles(to, pageNumber);

  const isList = to.name === 'list-all';
  const articlesWithSeoPromise = Promise.all([
    fetchArticles,
    isList ? Promise.resolve({}) : fetchSeo(to, $wordpressApi),
  ]);

  try {
    const [{ status, data }, seo] = await articlesWithSeoPromise;

    log('data', data);
    if (seo) log('seo', seo);

    if (status !== 200) {
      console.error('fetchArchivePageData response status', status);
      throw createError({ statusCode: status, data: data });
    }

    // редирект на канонический url, у главной нет data.url и редирект зацикливается
    if (data.url && data.url !== to.path) {
      return runWithContext(() => navigateTo(data.url, { redirectCode: 301, external: true }));
    }

    if (to.name === 'author-all' && status === 200 && data?.items?.[0]?.author?.integer_id) {
      console.warn('redirect', { to: data.items[0].author.profile });
      return runWithContext(() =>
        navigateTo(data.items[0].author.profile, { redirectCode: 301, external: true }),
      );
    }

    const { items, totalPages, title, adfoxParams, type, id, icon, breadcrumb } = data;
    const seoCorrect = seo.data ? seo.data : data?.seo;
    const normalizedSeo = parseSeoOrThrow(PageSeoInputSchema, seoCorrect);

    pageStore.addArchiveData({
      data: {
        type,
        id,
        totalPages,
        articles: items,
        title: title || '',
        seo: normalizedSeo,
        icon,
        breadcrumb,
      },
    });

    adfoxStore.addAdfoxParams(adfoxParams);
  } catch (error: unknown) {
    const apiError = error as { data?: unknown; stack?: unknown };
    log.error(error, apiError.data, apiError.stack);
    return handleApiError(error, runWithContext);
  }
});

function fetchSeo(
  to: RouteLocationNormalizedGeneric,
  $wordpressApi: IWordpressApi,
): Promise<SeoResponse | undefined> {
  const { page = 1, limit = 30 } = to.query;
  return $wordpressApi.fetchSeo(to.path, page as number, limit as number).catch(() => {});
}
